  import React,{useState} from 'react'

  export default function TextForm(props) {

  const [text,setText]=  useState("");

  const handleUpClick= ()=>{
      let newText=text.toUpperCase();
      setText(newText)
      document.title='Convert to upperCase'
      }

      const handleLoClick= ()=>{
        let newText=text.toLowerCase();
        setText(newText)
        document.title='Convert to lowerCase'
        }
    
        const handleClearClick= ()=>{
          let newText="";
          setText(newText)
          document.title='all clear'
          } 
      
      const handleBinaryClick=()=>{
        const binaryString=text.split('')
        .map((char) => char.charCodeAt(0).toString(2))
        .join(' ');

      setText(binaryString);
      document.title='Convert to 1 0'
      }   
      
      
        const handleToCopy =()=>{
          var text =document.getElementById('text');
          text.select();   // for select the text
          navigator.clipboard.writeText(text.value); // it's use to copy 
          document.title='copy Done'
        }


      // to remove extra space
      const handleToRemoveExtraSpace =()=>{
        let newText=text.split(/[ ]+/);
        setText(newText.join(" "))
        document.title="remove extra space"
      }
          

        const handleOnChange= (event)=>{
              // console.log("onChange");
        setText(event.target.value)

        }


    return (
      <div>
      <>
      <div className="container my-3" >
        <h1>{props.heading}</h1>
        <label for="text" className="form-label">label example</label>
        <textarea className="form-control"value={text} onChange={handleOnChange} style={{backgroundColor:props.mode==='dark'?'grey':'white',color:props.mode==='dark'?'white':'dark'}} id="text" rows="6"></textarea>
        </div>
        <button className='btn btn-danger mx-2' onClick={handleUpClick}>Convet to Uppercase</button>
        <button className='btn btn-primary mx-2' onClick={handleLoClick}>Convet to Lowercase</button>
        <button className='btn btn-primary mx-4' onClick={handleClearClick}>Clear the Text</button>
        <button className='btn btn-primary mx-4' onClick={handleBinaryClick}>Conver to Binary</button>
        <button className='btn btn-success mx-4' onClick={handleToCopy}>Text copy</button>
        <button className='btn btn-success mx-4' onClick={handleToRemoveExtraSpace}>Remove extra spaces</button>



        <div className="container my-3" >

      <h1>Text Counter</h1>
      <p><b>{text.split(' ').length}</b> word and <b> {text.length}</b> Charater</p>
      <p>{0.008 *text.split(' ').length} Minutes </p>
      <h2>Previwe</h2>

      <p><b>{text.length>0?text:"Enter some text inside the text area"}</b></p>
      <p>{text}</p>
        </div>

        </>
      </div>
    )
  }
